import { Section, Table } from 'nca-acquiring-theme';
import * as React from 'react';
export default {
  Section,
  Table,
  React
};